// extracted by mini-css-extract-plugin
export default {"CardTitle":"Cards_CardTitle__KbyQS","Card":"Cards_Card__tM74V","LikeButton":"Cards_LikeButton__ZAXSc","RemixButton":"Cards_RemixButton__BSMsM"};